import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateSpotMutationVariables = Types.Exact<{
  input: Types.UpdateSpotInput;
}>;


export type UpdateSpotMutation = { __typename?: 'MutationRoot', updateSpot: { __typename?: 'Spot', id: string } };

export type RemoveSpotMutationVariables = Types.Exact<{
  input: Types.RemoveSpotInput;
}>;


export type RemoveSpotMutation = { __typename?: 'MutationRoot', removeSpot: { __typename?: 'Spot', id: string } };

export type ReorderNarrationSpotMutationVariables = Types.Exact<{
  input: Types.ReorderNarrationSpotInput;
}>;


export type ReorderNarrationSpotMutation = { __typename?: 'MutationRoot', reorderNarrationSpot: boolean };


export const UpdateSpotDocument = gql`
    mutation UpdateSpot($input: UpdateSpotInput!) {
  updateSpot(input: $input) {
    id
  }
}
    `;

export function useUpdateSpotMutation() {
  return Urql.useMutation<UpdateSpotMutation, UpdateSpotMutationVariables>(UpdateSpotDocument);
};
export const RemoveSpotDocument = gql`
    mutation RemoveSpot($input: RemoveSpotInput!) {
  removeSpot(input: $input) {
    id
  }
}
    `;

export function useRemoveSpotMutation() {
  return Urql.useMutation<RemoveSpotMutation, RemoveSpotMutationVariables>(RemoveSpotDocument);
};
export const ReorderNarrationSpotDocument = gql`
    mutation ReorderNarrationSpot($input: ReorderNarrationSpotInput!) {
  reorderNarrationSpot(input: $input)
}
    `;

export function useReorderNarrationSpotMutation() {
  return Urql.useMutation<ReorderNarrationSpotMutation, ReorderNarrationSpotMutationVariables>(ReorderNarrationSpotDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateSpot })
 *   )
 * })
 */
export const mockUpdateSpotMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateSpotMutationVariables>, GraphQLContext<UpdateSpotMutation>, any>) =>
  graphql.mutation<UpdateSpotMutation, UpdateSpotMutationVariables>(
    'UpdateSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeSpot })
 *   )
 * })
 */
export const mockRemoveSpotMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveSpotMutationVariables>, GraphQLContext<RemoveSpotMutation>, any>) =>
  graphql.mutation<RemoveSpotMutation, RemoveSpotMutationVariables>(
    'RemoveSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReorderNarrationSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ reorderNarrationSpot })
 *   )
 * })
 */
export const mockReorderNarrationSpotMutation = (resolver: ResponseResolver<GraphQLRequest<ReorderNarrationSpotMutationVariables>, GraphQLContext<ReorderNarrationSpotMutation>, any>) =>
  graphql.mutation<ReorderNarrationSpotMutation, ReorderNarrationSpotMutationVariables>(
    'ReorderNarrationSpot',
    resolver
  )
